import React, { useState, useEffect } from "react";
import UserAnswerFeedbackData from "./UserAnswerFeedbackData";

const AttemptQuestion = ({ question, answers }) => {
  const [questionAnswer, setQuestionAnswer] = useState(null);

  useEffect(() => {
    const currentAnswer = findQuestionAnswer(question);
    setQuestionAnswer(currentAnswer);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [question, answers]);

  const findQuestionAnswer = (question) => {
    if (Array.isArray(answers)) {
      return answers.find(
        (answer) =>
          parseInt(answer.question_id) === parseInt(question.question_id)
      );
    }
  };

  const renderIcon = (questionAnswer) => {
    if (questionAnswer.score !== null) {
      if (questionAnswer.score > 0) {
        return <i className="fa fa-check text-success me-2"></i>;
      }
      return <i className="fa fa-times text-danger me-2"></i>;
    }
  };

  const renderMedia = (source) => {
    if (source.includes("you")) {
      const video_source = source.includes("youtu.be")
        ? "https://www.youtube.com/embed/" + source.split("be/")[1]
        : "https://www.youtube.com/embed/" + source.split("v=")[1];
      return (
        <div>
          <iframe
            src={video_source}
            title="YouTube video player"
            className="mw-100 w-100 shadow mb-3"
            height="500px"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          ></iframe>
          <a
            href={source}
            target="_blank"
            rel="noreferrer"
            className="btn btn-outline-accent"
          >
            <i className="fa fa-eye"></i> Ver en YouTube
          </a>
        </div>
      );
    }
    if (source.includes("drive")) {
      const video_source = source.includes("view")
        ? source.replace("view", "preview")
        : source;
      return (
        <div>
          <iframe
            src={video_source}
            className="mw-100 w-100 mb-3"
            height="auto"
            width="auto"
            title="video"
            style={{ minHeight: 300 }}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          ></iframe>
          <a
            href={source}
            target="_blank"
            rel="noreferrer"
            className="btn btn-outline-accent"
          >
            <i className="fa fa-eye"></i> Ver en Drive
          </a>
        </div>
      );
    }
    return (
      <video className="w-100" style={{ maxWidth: 500 }} playsInline controls>
        <source src={source} type="video/mp4" />
      </video>
    );
  };

  const renderContent = (questionAnswer) => {
    const source = String(questionAnswer.content);
    if (source.includes("http")) {
      return (
        <div className="row">
          <div className="col-12 col-md-6">{renderMedia(source)}</div>
          <div className="col-12 col-md-6">
            <UserAnswerFeedbackData questionAnswer={questionAnswer} />
          </div>
        </div>
      );
    }
    return (
      <p className="px-3">
        {renderIcon(questionAnswer)} {questionAnswer.content}
      </p>
    );
  };

  const renderAnswer = () => {
    if (questionAnswer && questionAnswer !== null) {
      return <div className="my-3">{renderContent(questionAnswer)}</div>;
    }
  };

  return (
    <div className="w-100 mb-4">
      <p className="p-3 bold mb-1 bg-light">
        #{question.order} - {question.content}
      </p>
      {renderAnswer()}
    </div>
  );
};

export default AttemptQuestion;
